import React, { useEffect, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { FaEye, FaEdit, FaTrash, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';

const QuizList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [gradeFilter, setGradeFilter] = useState('');
  const [quizzes, setQuizzes] = useState([]);
  const [selectedSlug, setSelectedSlug] = useState(null);

  const [res, loading, error, callAPI, statusCode] = useApiCallHooks();

  // Fetch quizzes on mount
  useEffect(() => {
    callAPI('get', 'admin/quizzes', '');
  }, []);

  // Set quiz data when response comes
  useEffect(() => {
    if (res?.data && Array.isArray(res.data)) {
      setQuizzes(res.data);
    }
  }, [res]);

  // Delete quiz handler
  const handleDelete = (slug) => {
    if (window.confirm("Are you sure you want to delete this quiz?")) {
      setSelectedSlug(slug);
      callAPI('delete', `admin/quizzes/${slug}`);
    }
  };

  // Toggle quiz status (active/inactive)
  const handleToggleStatus = (slug, currentStatus) => {
    const updatedStatus = !currentStatus;
    const payload = { slug, status: updatedStatus };
    callAPI('post', 'admin/update-quiz-status', payload);
    setSelectedSlug(slug);
  };

  // Handle delete or status update success
useEffect(() => {
  if ((statusCode === 204 || statusCode === 200) && selectedSlug) {
    toast.success("Quiz deleted successfully!");

    setTimeout(() => {
      callAPI('get', 'admin/quizzes', '');
    }, 1000);

    setSelectedSlug(null);
  }
}, [statusCode, selectedSlug, callAPI]);


  // Filter quizzes
  const filteredQuizzes = quizzes.filter(quiz =>
    (quiz.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quiz.level?.toLowerCase().includes(searchTerm.toLowerCase())) &&
    (gradeFilter ? quiz.grade === gradeFilter : true)
  );

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Quiz List"
                subTitle="Manage all quizzes and questions."
              />
            </div>
            <div className="col-md-6 text-end">
              <Link to="/quiz/add">
                <button className="btn btn-primary">Add Quiz</button>
              </Link>
            </div>
          </div>

          <div className="card shadow-sm rounded-lg mt-4 overflow-hidden">
            <div className="px-4 py-3 border-bottom bg-white">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <h5 className="mb-0 fw-semibold">Quizzes</h5>
                </div>
                <div className="col-md-4">
                  <div className="input-group">
                    <span className="input-group-text bg-white border-end-0">
                      <FaSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control border-start-0"
                      placeholder="Search by name or level"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={gradeFilter}
                    onChange={(e) => setGradeFilter(e.target.value)}
                  >
                    <option value="">Filter by grade</option>
                    <option value="Grade 1">Grade 1</option>
                    <option value="Grade 2">Grade 2</option>
                    <option value="Grade 3">Grade 3</option>
                    <option value="Grade 4">Grade 4</option>
                    <option value="Grade 5">Grade 5</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="bg-light text-dark text-uppercase small">
                  <tr>
                    <th className="px-4 py-2">Sr No.</th>
                    <th className="px-4 py-2">Quiz Name</th>
                    <th className="px-4 py-2">Age</th>
                    <th className="px-4 py-2">Level</th>
                    <th className="px-4 py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredQuizzes.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        No quizzes found.
                      </td>
                    </tr>
                  ) : (
                    filteredQuizzes.map((quiz, index) => (
                      <tr key={quiz.id} className="border-bottom">
                        <th className="px-4 py-2">{index + 1}</th>
                        <td className="px-4 py-2">{quiz.name}</td>
                        <td className="px-4 py-2">{quiz.age}</td>
                        <td className="px-4 py-2">{quiz.level}</td>
                        <td className="px-4 py-2 text-center">
                          <div className="d-flex justify-content-center gap-2 align-items-center">
                            <span
                              className={`badge ${
                                quiz.status ? 'bg-success' : 'bg-secondary'
                              } cursor-pointer`}
                              onClick={() => handleToggleStatus(quiz.slug, quiz.status)}
                              title={quiz.status ? 'Click to deactivate' : 'Click to activate'}
                            >
                              {quiz.status ? 'Active' : 'Inactive'}
                            </span>
                            <Link to={`/question-list/${quiz.slug}`}>
                              <button className="sys-list-table__action view" title="View Quiz">
                                <FaEye />
                              </button>
                            </Link>
                            <Link to={`/quiz-edit/${quiz.slug}`}>
                              <button className="sys-list-table__action edit" title="Edit Quiz">
                                <FaEdit />
                              </button>
                            </Link>
                            <button
                              className="sys-list-table__action delete"
                              title="Delete Quiz"
                              onClick={() => handleDelete(quiz.slug)}
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default QuizList;